const wrapper = {
  marginBottom: 3,
  display: 'flex',
  justifyContent: 'space-between',
};

const firstTabButton = {
  marginRight: 1,
};

export default { wrapper, firstTabButton };
